import React from "react";
import { Typography, Modal } from "@mui/material";
import CustomButton from "../../components/buttons/CustomButton";
import ErrorIcon from "../../../assets/images/ErrorIcon.svg";
import styles from "./popup.module.css";

function DuplicateRowPopup({ popupOpen, duplicateMessage = [], handlePopupOpen }) {
    return (
        <div>
            <Modal open={popupOpen} onClose={handlePopupOpen}>
                <div className={styles.modalContainer}>
                    <div className={styles.dialogBox}>
                        <div className={styles.dialogBoxContent}>
                            <img src={ErrorIcon} alt="Error icon" width={30} height={30} />
                            <Typography className={styles.header}>
                                Found duplicate combinations
                            </Typography>
                        </div>

                        <div className={styles.alertList}>
                            {duplicateMessage.map((mess, index) => (
                                <div key={index} className={styles.alertItem}>
                                    <ul style={{ paddingLeft: '20px', margin: 0 }}>
                                        <li><Typography className={styles.alertId}> {mess}</Typography></li>
                                    </ul>
                                </div>
                            ))}
                        </div>

                        <div className={styles.dialogBtn} style={{ justifyContent: 'end' }}>
                            <CustomButton label="Cancel" type="popupCancelSmall" onClick={handlePopupOpen} />
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default DuplicateRowPopup;
